import script from "./GroupView.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupView.vue?vue&type=script&setup=true&lang=js"

import "./GroupView.vue?vue&type=style&index=0&id=08dd4d63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08dd4d63"]])

export default __exports__